import moment from "moment"
import { Project } from "../types/project.type"
import { PublicBooking, ServiceBooking, ServiceCustomForm } from "../types/service.type"
import { formatDob } from "./formatter"

/** Flatten API customForm whether it is a single object or an array of objects. */
function customFormEntries(
  cf: ServiceBooking["customForm"] | unknown
): [string, unknown][] {
  if (!cf) return []
  if (Array.isArray(cf)) {
    return cf.flatMap((item) =>
      item && typeof item === "object"
        ? Object.entries(item as Record<string, unknown>)
        : []
    )
  }
  if (typeof cf === "object") {
    return Object.entries(cf as Record<string, unknown>)
  }
  return []
}

export function generateBookingMesssage(
  booking: PublicBooking | undefined,
  project: Project | undefined,
  customForms: ServiceCustomForm[] | undefined
): string {
  if (!booking) {
    return "Hi Admin"
  }

  const projectName = project?.name || "Admin"

  const customLines = customFormEntries(booking.customForm as unknown)
    .map(([key, value]) => {
      const formDef = customForms?.find((form) => form.key === key)
      const label = formDef?.label || key
      const displayValue =
        formDef?.type === 'dob'
          ? formatDob(value as string | Date | null | undefined)
          : value
      return `- ${label}: ${displayValue}`
    })
    .join("\n")

  const message = `Halo ${projectName}, Saya melakukan booking dengan detail berikut:
- Nama: ${booking.customer.name}
- No. HP: ${booking.customer.phoneNo}
- Lokasi: ${booking.isExternal ? booking.attendedAddress : project?.offsiteName}
- Service: ${booking.serviceJson.map((service) => service.title).join(", ")}
- Waktu: ${moment(booking.reservationDateTime).format("DD MMM YYYY HH:mm A")} *(admin akan mengkonfirmasi kembali jam yang anda pilih, jika jam tersebut full akan di sesuaikan dengan jam yg tersedia)*
${customLines ? `${customLines}\n` : ""}- Remark: ${booking.remark || "-"}`

  return message.trim()
}
